export default __webpack_public_path__ + "static/media/sprint-retro.3fd68fce.svg";